<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0 widget-header">
                <div class="title">
                    <i class="fa fa-align-justify mr-2"></i> {{ trans.title }}
                </div>

                <dropdown-years
                    class="select-month"
                    :year="currentYear"
                    :years-count="5"
                    :year-start="2020"
                    :choose-action="chooseYear"
                    :show-buttons="true"
                    :loading="loading"
                ></dropdown-years>
            </b-card-header>
            <b-card-body>
                <div class="loading-box" v-if="loading">
                    <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                </div>

                <div v-if="!loading">
                    <bar-chart
                        :chart-data="graphData.chartData"
                        :chart-label="graphData.chartLabel"
                        :chart-options="graphData.chartOptions"
                        :height="280"
                    ></bar-chart>
                </div>

            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'statistics-monthly',

        props: {
            'trans': {
                type: Object
            },
            'year': {
                type: Number
            }
        },

        data() {
            var trans = this.trans;

            return {
                loading: false,
                currentYear: this.year,

                graphData: {
                    chartLabel: [1,2,3,4,5,6,7,8,9,10,11,12],
                    chartData: [
                        {
                            label: '-',
                            data: [0,0,0,0,0,0,0,0,0,0,0,0],
                            backgroundColor: '#D344FE'
                        }
                    ],
                    chartOptions: {
                        legend: {
                            display: false
                        },
                        tooltips: {
                            mode: 'index',
                            callbacks: {
                                footer: function(tooltipItems, data) {
                                    var sum = 0;

                                    tooltipItems.forEach(function(tooltipItem) {
                                        sum += data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                    });

                                    sum = Math.ceil(sum * 100) / 100;

                                    return trans.together +': ' + sum + " h.";
                                }
                            }
                        },
                        hover: {
                            mode: 'index',
                            intersect: true
                        },
                        scales: {
                            xAxes: [{
                                stacked: true,
                                gridLines: {
                                    drawOnChartArea: false
                                }
                            }],
                            yAxes: [{
                                stacked: true,
                                gridLines: {
                                    drawOnChartArea: false
                                }
                            }]
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                }
            };
        },

        mounted() {
            this.loadData();
        },

        methods: {

            chooseYear(year) {
                this.currentYear = year;

                this.loadData();
            },

            loadData() {
                this.loading = true;
                var _this = this;

                axios.get("/dashboard/stats-yearly/"+this.currentYear).then(function (response) {
                    if(response && response.data)
                    {
                        _this.graphData.chartData = response.data;
                        _this.loading = false;
                    }
                }, function (error) {
                    _this.$notify({
                      type: 'error',
                      title: 'Error!',
                      text: typeof error.response !== "undefined" && typeof error.response.data !== "undefined" && error.response.data.message ? error.response.data.message : 'An error has occured.'
                    });

                    _this.loading = false;
                });
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/widgets/StatisticsMonthly.vue